import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PreschoolPlanCard } from '@/components/DiaryPreschoolPlans/PreschoolPlanCard';
import { PreschoolPlanModal } from '@/components/DiaryPreschoolPlans/PreschoolPlanModal';
import type { PreschoolEducationPlan } from '@/types/diary';

interface Props {
  plans: PreschoolEducationPlan[];
}

export const DiaryPreschoolPlans: React.FC<Props> = ({ plans }) => {
  const { t } = useTranslation();
  const [openedPlan, setOpenedPlan] = useState<PreschoolEducationPlan>();

  if (!plans.length) {
    return null;
  }

  return (
    <div>
      <p className="text-subhead-14 pt-6 pb-2 text-subtle-foreground md:py-3 md:text-muted-foreground">
        {t('diary.preschoolPlans')}
      </p>
      <div className="flex flex-col gap-2 md:gap-3">
        {plans.map((plan) => (
          <PreschoolPlanCard
            key={plan.id}
            plan={plan}
            onClick={() => setOpenedPlan(plan)}
          />
        ))}
      </div>

      {openedPlan && (
        <PreschoolPlanModal
          plan={openedPlan}
          onClose={() => setOpenedPlan(undefined)}
        />
      )}
    </div>
  );
};
